import React from 'react';
import { ButtonContainer } from '../jsxElements/Button';
import { AmplitudeEvent } from '../types';
import { AmpFlagSet } from '../amplitude';

export type ProvidenceButtonListButton = {
    amplitudeEvent?: AmplitudeEvent;
    data: string;
    title: string;
    url?: string;
    flow?: string;
    intent?: string;
    ctaType?: string;
};

export type ProvidenceButtonListData = {
    buttons: ProvidenceButtonListButton[];
};

type ProvidenceButtonListArgs = {
    data: ProvidenceButtonListData;
    disableButtons: boolean;
    featureFlags: AmpFlagSet;
    overrideContainerStyle?: boolean;
    sendMessage: (message: string) => void;
    sendPostBack: (value: any) => void;
};

export const ProvidenceButtonList: React.FC<ProvidenceButtonListArgs> = ({
    data,
    disableButtons,
    featureFlags,
    overrideContainerStyle,
    sendMessage,
    sendPostBack,
}: ProvidenceButtonListArgs) => (
    <ButtonContainer
        overrideContainerStyle={overrideContainerStyle}
        buttons={data.buttons.map((button, index) => {
            return {
                button,
                disableChildMargin: true,
                disableButtons,
                featureFlags,
                index,
                sendMessage,
                sendPostBack,
                ctaType: button.ctaType,
            };
        })}
        featureFlags={featureFlags}
    />
);
